import { Link } from "react-router-dom";
import { 
  Phone, 
  Envelope, 
  MapPin, 
  Clock,
  LinkedinLogo,
  FacebookLogo,
  TwitterLogo
} from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_eatech-portal/artifacts/l3j7s7xc_logo.png";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img 
              src={LOGO_URL} 
              alt="E@Tech Logo" 
              className="h-12 w-auto brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              E@Tech - La technologie au service de la réussite scolaire. 
              Votre partenaire informatique dédié aux établissements d'enseignement.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors" aria-label="LinkedIn">
                <LinkedinLogo size={24} weight="fill" />
              </a>
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors" aria-label="Facebook">
                <FacebookLogo size={24} weight="fill" />
              </a>
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors" aria-label="Twitter">
                <TwitterLogo size={24} weight="fill" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4 font-['Outfit']">Nos Services</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li><Link to="/que-faisons-nous" className="footer-link hover:text-sky-400">Gestion de Projet</Link></li>
              <li><Link to="/que-faisons-nous" className="footer-link hover:text-sky-400">Fourniture de Matériel</Link></li>
              <li><Link to="/que-faisons-nous" className="footer-link hover:text-sky-400">Cybersécurité</Link></li>
              <li><Link to="/que-faisons-nous" className="footer-link hover:text-sky-400">Cloud</Link></li>
              <li><Link to="/que-faisons-nous" className="footer-link hover:text-sky-400">Conseil Stratégique</Link></li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-lg mb-4 font-['Outfit']">Navigation</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li><Link to="/" className="footer-link hover:text-sky-400">Accueil</Link></li>
              <li><Link to="/qui-nous-sommes" className="footer-link hover:text-sky-400">Qui nous sommes</Link></li>
              <li><Link to="/que-faisons-nous" className="footer-link hover:text-sky-400">Que faisons-nous</Link></li>
              <li><Link to="/nous-contacter" className="footer-link hover:text-sky-400">Nous contacter</Link></li>
              <li><Link to="/demande-devis" className="footer-link hover:text-sky-400">Demande de devis</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4 font-['Outfit']">Contact</h4>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-sky-400 flex-shrink-0 mt-0.5" weight="fill" />
                <span>+33 3 55 20 50 51</span>
              </li>
              <li className="flex items-start gap-3">
                <Envelope size={18} className="text-sky-400 flex-shrink-0 mt-0.5" weight="fill" />
                <span>contact@eatech.fr</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-sky-400 flex-shrink-0 mt-0.5" weight="fill" />
                <span>Lun - Ven: 10:00 - 18:00</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-sky-400 flex-shrink-0 mt-0.5" weight="fill" />
                <div>
                  <span>11 rue d'Amsterdam</span><br/>
                  <span>54500 VANDOEUVRE-LES-NANCY</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>&copy; {new Date().getFullYear()} E@Tech. Tous droits réservés.</p>
            <div className="flex gap-6">
              <Link to="/mentions-legales" className="hover:text-sky-400 transition-colors">Mentions légales</Link>
              <Link to="/politique-confidentialite" className="hover:text-sky-400 transition-colors">Politique de confidentialité</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
